import { useRef, useCallback } from 'react';

export const useSlowScroll = (onChange, step = 1000) => {
  const lastScrollTime = useRef(0);
  
  const handleWheel = useCallback((event) => {
    event.preventDefault();
    const now = new Date().getTime();
    if (now - lastScrollTime.current > step) {
      const input = event.target;
      const [hours, minutes] = input.value.split(':').map(Number);
      let newMinutes = minutes + (event.deltaY > 0 ? 1 : -1);
      let newHours = hours;

      if (newMinutes >= 60) {
        newHours = (newHours + 1) % 24;
        newMinutes = 0;
      } else if (newMinutes < 0) {
        newHours = (newHours - 1 + 24) % 24;
        newMinutes = 59;
      }

      const newValue = `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`;
      onChange({ target: { value: newValue } });
      lastScrollTime.current = now;
    }
  }, [onChange, step]);

  return handleWheel;
};